export default __webpack_public_path__ + "static/media/a011-1.06496bd6.svg";